import { TrackableAction } from '@apps/clos-sessions/state/processing';
import { ClosArchiveBucket, ClosAsset, ClosAssetGUID } from './types';

export class FetchArchiveBucket implements TrackableAction {
  static readonly type = '[Archives Assets] Fetch Archives Assets';

  readonly track = true;

  constructor(readonly payload: { archiveId: string; bucket: ClosArchiveBucket }) {}
}

export class FetchArchiveBucketNextPaginationChunk implements TrackableAction {
  static readonly type = '[Archives Assets] Fetch Archives Assets Next Pagination Chunk';

  readonly track = true;

  constructor(readonly payload: { archiveId: string; bucket: ClosArchiveBucket }) {}
}

export class RemoveArchiveAssets implements TrackableAction {
  static readonly type = '[Archives Assets] Remove Assets';

  readonly track = true;

  constructor(readonly payload: { archive: { id: string }; assets: ClosAsset[] }) {}
}

export class RateArchiveAsset implements TrackableAction {
  static readonly type = '[Archives Assets] Rate Asset';

  readonly track = true;

  constructor(readonly payload: { archive: { id: string }; asset: ClosAsset; score: number }) {}
}

export class UploadAssets {
  static readonly type = '[Archives Assets] Upload Asset';

  constructor(
    readonly payload: {
      archive: { id: string };
      bucket: ClosArchiveBucket;
      guids: ClosAssetGUID[];
    },
  ) {}
}

export class CancelAssetUpload {
  static readonly type = '[Archives Assets] Cancel Asset Upload';

  constructor(readonly payload: { id: ClosAssetGUID }) {}
}
